
export const getQueryParams = (query) => {
  return query ? `?${(new URLSearchParams(query)).toString()}` : ''
}

